var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('a-tabs',{on:{"tabClick":_vm.refresh}},[_c('a-tab-pane',{key:"strategy",attrs:{"tab":"策略管理"}},[_c('Strategy')],1),_c('a-tab-pane',{key:"tradeAccount",attrs:{"tab":"账户管理"}},[_c('TradeAccount')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }